import { render } from "./GigaManagerCasebooks.vue?vue&type=template&id=e7fdb392"
import script from "./GigaManagerCasebooks.vue?vue&type=script&lang=js"
export * from "./GigaManagerCasebooks.vue?vue&type=script&lang=js"

import exportComponent from "/Users/fanhaipeng/code/giga-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__